import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../../../store";
import {
  storeStarterSelectSidebarShow,
  storeStarterSelectSidebarUnfoldable,
  storeStarterSetLayout,
} from "../datasources/_starter.layout.store.slice";

export const useStarterSidebarController = () => {
  const dispatch = useDispatch();
  const unfoldable = useTypedSelector(storeStarterSelectSidebarUnfoldable);
  const sidebarShow = useTypedSelector(storeStarterSelectSidebarShow);

  const setSidebarShow = (visible: boolean) => {
    dispatch(storeStarterSetLayout({ type: "set", sidebarShow: visible }));
  };
  const toggleSidebarFold = () => {
    dispatch(
      storeStarterSetLayout({ type: "set", sidebarUnfoldable: !unfoldable }),
    );
  };

  return {
    state: {
      unfoldable,
      sidebarShow,
    },
    action: {
      setSidebarShow,
      toggleSidebarFold,
    },
  };
};
